export default "__VITE_ASSET__AjM$_pDu__"